module.exports = __webpack_public_path__ + "images/role-coach.a99f33c16e975f44403c7b1f185f5d4f.png";